// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3FB_Z","header":"Messages_header__2dp2s"};